export const ProductName = "Green Crypto X";
